export default __webpack_public_path__ + "static/media/car_info_image.c2d55f3d.png";